/**
 * Phone display helpers for the telephony screens (plan 2026_10_31_lmt_calls). The api stores numbers in E.164.
 */

/** `+37129990001` -> `+371 2999 0001`; any other number as it is. */
export function formatPhoneE164(e164: string): string {
  const lv = /^\+371(\d{4})(\d{4})$/.exec(e164);
  return lv === null ? e164 : `+371 ${lv[1] ?? ''} ${lv[2] ?? ''}`;
}

/** Talk time as m:ss, or h:mm:ss from an hour. */
export function formatTalkTime(seconds: number): string {
  const s = String(seconds % 60).padStart(2, '0');
  const m = Math.floor(seconds / 60) % 60;
  const h = Math.floor(seconds / 3600);
  return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${s}` : `${m}:${s}`;
}
